import { rangeStep } from 'lodash/fp';
import prepareOptions from './prepareOptions';

export default ({
  fromYear,
  toYear = new Date().getFullYear() + 1,
  withReverse,
  step = 1,
}) => {
  const years = rangeStep(step, fromYear, toYear);

  return prepareOptions(withReverse ? years.reverse() : years, {
    stringifyValues: false,
  });
};
